export const OPEN_PROFILE = "common/open-profile";
export const OPEN_BOOKMARKS = "common/open-bookmarks";
export const CLOSE_PROFILE = "common/close-profile";
export const CLOSE_BOOKMARKS = "common/close-bookmarks";
export const REFRESH_BOOKMARKS = "common/refresh-bookmarks";
export const SET_GLOBAL_FILTERS = "common/set_global_filter";
export const SET_GLOBAL_DYNAMIC_FILTERS = "common/set_global_dynamic_filter";

export type Action =
	| { type: OPEN_BOOKMARKS }
	| { type: OPEN_PROFILE }
	| { type: CLOSE_PROFILE }
	| { type: REFRESH_BOOKMARKS }
	| { type: CLOSE_BOOKMARKS }
	| { type: SET_GLOBAL_FILTERS }
	| { type: SET_GLOBAL_DYNAMIC_FILTERS };



// WEBPACK FOOTER //
// ./src/action/CommonActionTypes.js